import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyUser } from '@core/services/profile.service';

@Component({
  selector: 'app-platform-user-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './platform-user-card.component.html',
  styleUrls: ['./platform-user-card.component.css'],
})
export class PlatformUserCardComponent {
  @Input({ required: true }) user!: CompanyUser;
  @Input() initials: string = '';
  @Input() avatarColor: string = '#9CA3AF';
  @Input() department: string = '';
  @Input() agentIcons: Array<{ path: string; bg: string; disabled?: boolean }> = [];
  @Input() queryCount: number | string = 0;
}